const validate = values => {
	const errors = {}
	if (!values.pry_form_locality) {
		errors.pry_form_locality = 'Este Campo es Obligatorio'
	}
	if (!values.pry_address_street) {
		errors.pry_address_street = 'Este Campo es Obligatorio'
	}
	if (!values.pry_zip_code) {
		errors.pry_zip_code = 'Este Campo es Obligatorio'
	}
	return errors
}

export default validate


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsPryAddressForm.js
 **/